const _isSystemSupported = () => {
  return navigator?.deviceMemory >= 4 ?? false;
};

const _isWebGL2Supported = () => {
  if ('isWebGL2Supported' in window) {
    return window['isWebGL2Supported'];
  }

  const options = {
    alpha: true,
    antialias: true,
    premultipliedAlpha: true,
    preserveDrawingBuffer: false,
    stencil: true,
  };
  const canvas = document.createElement('canvas');
  const gl = canvas.getContext('webgl2', options);

  if (gl && 'getExtension' in gl) {
    gl.getExtension('WEBGL_lose_context').loseContext();
  }

  window['isWebGL2Supported'] = !!gl;
  return !!gl;
};

export const isIVFrameSupported = () => {
  return _isSystemSupported() && _isWebGL2Supported();
};
